import {gql} from '@apollo/client';

export const REVIEW_POD = gql`
    mutation ReviewPod($orderId: Long!, $isApproved: Boolean!, $reasons: [String!], $reviewerAccountId: Long, $podManualReviewId: Long!, $reviewNote: String) {
        reviewPod(orderId: $orderId, isApproved: $isApproved, reasons: $reasons, reviewerAccountId: $reviewerAccountId, podManualReviewId: $podManualReviewId, reviewNote: $reviewNote) {
            id
            trackingNumber
            podReviewStatus
            podStatusUpdatedAt
            podReviewMessage
            updatedAt
        }
    }
`;

export interface ReviewPodResponse {
    reviewPod: {
        id: number;
        trackingNumber: string;
        podReviewStatus: number;
        podStatusUpdatedAt: string;
        podReviewMessage: string[];
        updatedAt: string;
    };
}

export const DOWNLOAD_POD_REVIEW_TERMINATED = gql`
    mutation DownloadPodReviewTerminated($filters: PodReviewFiltersTypeInput, $language: String, $timezone: String) {
        downloadPodReviewTerminated(filters: $filters, language: $language, timezone: $timezone) {
            success
            errorCode
            fileName
        }
    }
`;

export interface DownloadPodReviewTerminatedResponse {
    downloadPodReviewTerminated: {
        success: boolean;
        errorCode?: string;
        fileName?: string;
    };
}
